import { useCallback as f } from "react";
import { _ as b } from "../../../lodash-DeBCDn4U.js";
import { isEmpty as v } from "@biron-data/react-components";
import { buildMetricLabel as C } from "../../../configuration/utils.js";
import { getAvailableDimensions as c } from "../../../configuration/useRequirements.js";
import { a as u, K as y, n as w, c as A } from "../../../dummyModel-DGc8qBEQ.js";
const k = (e, s, a) => f(
  (l, t, p, m) => b(e).map((o) => {
    const r = o ? u(l, o) : void 0, d = o && r ? C({
      ...o,
      additionalFilters: y(o.additionalFilters, c(l, s, e.map((i) => i.viewCode))),
      metricDef: r
    }, a) : void 0, n = o && t && d ? w(t, {
      metricCode: `${o.metricCode}`,
      metricAlias: d,
      viewCode: o.viewCode
    }, p) : void 0;
    return {
      type: A.NUMBER,
      label: n ?? "",
      value: o.metricCode,
      selected: !v(m.find((i) => i.reference.alias === n))
    };
  }).sortBy("label").value(),
  [e, a]
);
export {
  k as useMetricOptions
};
//# sourceMappingURL=MetricFilterSelector.hooks.js.map
